import { render, staticRenderFns } from "./Competitor.vue?vue&type=template&id=ccd1585a&scoped=true&"
import script from "./Competitor.vue?vue&type=script&lang=js&"
export * from "./Competitor.vue?vue&type=script&lang=js&"
import style0 from "./Competitor.vue?vue&type=style&index=0&id=ccd1585a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccd1585a",
  null
  
)

export default component.exports